module.exports = {
  apiUrl: "https://dev.design.unirac.com",
  domainName: "unirac.com",
  forgotPasswordLink: "https://dev.services.unirac.com/forgotpassword",
  analyticsUrl: "https://dev.analytics.unirac.com",
};
